<script>
    import Router from './routes/index.svelte';
</script>

<style>
    main {
        text-align: center;
        width: 100%;
        margin: 0 auto 100px;
        background: var(--background-color);
    }
</style>

<main>
    <Router/>
</main>
